import type { TFilterPayload } from '@/creditflowresearch/domain/vo/Bondscreener';
import type { IDictionaryIndustry } from '@/creditflowresearch/domain/vo/IDictionary';
import { mapViewFiltersToDraft } from './Sidebar/mapBondScreenerViewFilters';
import { withDefaultSelectedSubindustryIds, withSelectedSubindustryIds } from './segmentIndustryMapping';

export const buildViewFilterPayload = (
  viewFilters: Partial<TFilterPayload> | null,
  noViewFilters: Partial<TFilterPayload>,
  industries: IDictionaryIndustry[],
): TFilterPayload => {
  const draftFilters = mapViewFiltersToDraft(viewFilters ?? noViewFilters);

  return viewFilters
    ? withSelectedSubindustryIds(industries, draftFilters)
    : withDefaultSelectedSubindustryIds(industries, draftFilters);
};
